import { GitHub as GitHubIcon } from "@mui/icons-material";
import { ScoreCard } from "../components/PolicyScoreCard";
import {
  AixIcon,
  AlmaLinuxIcon,
  AristaIcon,
  AwsIcon,
  AzureIcon,
  CentosIcon,
  ChefInfraIcon,
  CiscoIcon,
  CloudflareIcon,
  DebianIcon,
  DigitalOceanIcon,
  DnsIcon,
  DockerIcon,
  EntraIdIcon,
  F5Icon,
  FedoraIcon,
  FordIcon,
  FortinetIcon,
  FreebsdIcon,
  GcpIcon,
  GenericPolicyIcon,
  GitlabIcon,
  GoogleWorkspaceIcon,
  GrafanaIcon,
  HpeIcon,
  KubernetesIcon,
  LinuxIcon,
  MacosIcon,
  McpIcon,
  Ms365Icon,
  NginxIcon,
  OciIcon,
  OktaIcon,
  PanOsIcon,
  RedhatIcon,
  RockyLinuxIcon,
  ShodanIcon,
  SlackIcon,
  SnowflakeIcon,
  SuseIcon,
  TailscaleIcon,
  TerraformIcon,
  UbuntuIcon,
  UnifiIcon,
  VmwareIcon,
  WindowsIcon,
} from "~/icons";

import { BsiIcon } from "~/images/compliance-entry-page/BsiIcon";

export function policyIcon(
  title: ScoreCard["title"],
  fontSize: "small" | "medium" | "large" = "small",
) {
  let lower = title.toLowerCase();

  if (lower.includes("redhat") || lower.includes("red hat")) {
    return <RedhatIcon {...{ fontSize }} />;
  } else if (lower.split(" ").includes("ford")) {
    return <FordIcon {...{ fontSize }} />;
  } else if (lower.split(" ").includes("f5")) {
    return <F5Icon {...{ fontSize }} />;
  } else if (lower.includes("fortinet")) {
    return <FortinetIcon {...{ fontSize }} />;
  } else if (lower.includes("aix")) {
    return <AixIcon {...{ fontSize }} />;
  } else if (lower.includes("almalinux")) {
    return <AlmaLinuxIcon {...{ fontSize }} />;
  } else if (lower.includes("arista")) {
    return <AristaIcon {...{ fontSize }} />;
  } else if (lower.includes("bsi")) {
    return <BsiIcon {...{ fontSize }} />;
  } else if (lower.includes("kubernetes")) {
    if (lower.includes("(eks)")) {
      return <AwsIcon {...{ fontSize }} />;
    } else if (lower.includes("(aks)")) {
      return <AzureIcon {...{ fontSize }} />;
    } else if (lower.includes("(gke)")) {
      return <GcpIcon {...{ fontSize }} />;
    }
    return <KubernetesIcon {...{ fontSize }} />;
  } else if (lower.includes("fedora")) {
    return <FedoraIcon {...{ fontSize }} />;
  } else if (lower.includes("centos")) {
    return <CentosIcon {...{ fontSize }} />;
  } else if (lower.includes("debian")) {
    return <DebianIcon {...{ fontSize }} />;
  } else if (lower.includes("ubuntu")) {
    return <UbuntuIcon {...{ fontSize }} />;
  } else if (lower.includes("nginx")) {
    return <NginxIcon {...{ fontSize }} />;
  } else if (lower.includes("suse")) {
    return <SuseIcon {...{ fontSize }} />;
  } else if (lower.includes("terraform")) {
    return <TerraformIcon {...{ fontSize }} />;
  } else if (lower.includes("amazon") || lower.includes("aws")) {
    return <AwsIcon {...{ fontSize }} />;
  } else if (lower.includes("apple") || lower.includes("macos")) {
    return <MacosIcon {...{ fontSize }} />;
  } else if (lower.includes("google workspace")) {
    return <GoogleWorkspaceIcon {...{ fontSize }} />;
  } else if (lower.includes("rocky linux")) {
    return <RockyLinuxIcon {...{ fontSize }} />;
  } else if (lower.includes("slack")) {
    return <SlackIcon {...{ fontSize }} />;
  } else if (lower.includes("oracle cloud")) {
    return <OciIcon {...{ fontSize }} />;
  } else if (lower.includes("oracle linux")) {
    return <OciIcon {...{ fontSize }} />;
  } else if (lower.includes("okta")) {
    return <OktaIcon {...{ fontSize }} />;
  } else if (
    lower.includes("google cloud") ||
    lower.includes("gcp") ||
    lower.includes("google container-optimized")
  ) {
    return <GcpIcon {...{ fontSize }} />;
  } else if (lower.includes("vmware")) {
    // vmware vsphere, photon
    return <VmwareIcon {...{ fontSize }} />;
  } else if (lower.includes("github")) {
    return <GitHubIcon {...{ fontSize }} />;
  } else if (lower.includes("gitlab")) {
    return <GitlabIcon {...{ fontSize }} />;
  } else if (lower.includes("docker")) {
    return <DockerIcon {...{ fontSize }} />;
  } else if (lower.includes("linux")) {
    return <LinuxIcon {...{ fontSize }} />;
    // Check Azure before MS365 check so we don't put the MS logo on Azure policies
  } else if (lower.includes("azure")) {
    return <AzureIcon {...{ fontSize }} />;
    // Check Entra ID before Microsoft because policy name can be "Mondoo Microsoft Entra ID Security"
  } else if (lower.includes("entra id")) {
    return <EntraIdIcon {...{ fontSize }} />;
    // Check Windows before Microsoft so we don't put the MS logo on Windows policies
  } else if (
    lower.includes("windows") ||
    lower.includes("ntlmv1") ||
    lower.includes("smbv1") ||
    lower.includes("active directory")
  ) {
    return <WindowsIcon {...{ fontSize }} />;
  } else if (lower.includes("microsoft")) {
    if (lower.includes("365")) {
      return <Ms365Icon {...{ fontSize }} />;
    }
    return <WindowsIcon {...{ fontSize }} />;
  } else if (lower.includes("dns")) {
    return <DnsIcon {...{ fontSize }} />;
  } else if (lower.includes("shodan")) {
    return <ShodanIcon {...{ fontSize }} />;
  } else if (lower.includes("cisco")) {
    return <CiscoIcon {...{ fontSize }} />;
  } else if (lower.includes("chef infra")) {
    return <ChefInfraIcon {...{ fontSize }} />;
  } else if (lower.includes("cloudflare")) {
    return <CloudflareIcon {...{ fontSize }} />;
  } else if (lower.includes("freebsd")) {
    return <FreebsdIcon {...{ fontSize }} />;
  } else if (lower.includes("tailscale")) {
    return <TailscaleIcon {...{ fontSize }} />;
  } else if (lower.includes("snowflake")) {
    return <SnowflakeIcon {...{ fontSize }} />;
  } else if (lower.includes("palo alto")) {
    return <PanOsIcon {...{ fontSize }} />;
  } else if (lower.includes("juniper") || lower.includes("junos")) {
    return <HpeIcon {...{ fontSize }} />;
  } else if (lower.includes("mcp")) {
    return <McpIcon {...{ fontSize }} />;
  } else if (lower.includes("grafana")) {
    return <GrafanaIcon {...{ fontSize }} />;
  } else if (
    lower.includes("digitalocean") ||
    lower.includes("digital ocean")
  ) {
    return <DigitalOceanIcon {...{ fontSize }} />;
  } else if (lower.includes("unifi")) {
    return <UnifiIcon {...{ fontSize }} />;
  } else {
    return <GenericPolicyIcon {...{ fontSize }} />;
  }
}
